import { EventAssociatedModel, EventFriend } from '~/types/adamTypes';

export const useAppEventFriend = () => {
  const { createEvent, setContentId } = useAppEvent(
    EventAssociatedModel.Friend
  );

  const getEventData = () => {
    const eventData: any = {};

    return eventData;
  };

  const send = async (event: EventFriend, contentId?: string, data?: any) => {
    let eventData = getEventData();
    if (contentId) {
      setContentId(contentId);
    }
    if (data) {
      eventData = {
        ...eventData,
        ...data,
      };
    }

    await createEvent(event, eventData);
  };

  return {
    send,
  };
};
